<div class="accountHeader">
  <div class="accountHeader__cell accountHeader__cell--site">
    <div class="accountHeader__checkbox" ppTooltip [ppTitle]="selectAllTooltip">
      <pp-checkbox
        [ppChecked]="isAllSelected"
        (ppOnValueChange)="selectAll()"
        ppSize="medium"
        class="checkbox"
        ppType="solid"
        [ppDisabled]="selectAllDisabled"
      />
    </div>

    <div
      class="accountHeader__expandToggle"
      (click)="expandAll()"
      ppTooltip
      [class.accountHeader__expandToggle--disabled]="expandAllDisabled"
      [ppTitle]="expandAllTooltip"
    >
      <pp-icon
        [ppSrc]="
          allUsersExpanded ? EIconPath.ICON_NAV_ARROW_DOWN_14 : EIconPath.ICON_NAV_ARROW_RIGHT_14
        "
        ppClass="setSize14"
        ppColor="inherit"
      />
    </div>

    <div class="accountHeader__cellContent accountHeader__cellContent--site">
      {{ 'site' | ppTranslate }}
    </div>
  </div>

  @for (basicField of basicFields; track basicField) {
    <div class="accountHeader__cell" [ngClass]="basicField.class">
      <div class="accountHeader__cellContent">
        {{ basicField.translationKey | ppTranslate }}
      </div>
    </div>
  }

  @for (customField of ppCustomFields; track customField.id) {
    <div class="accountHeader__cell accountHeader__cell--customField">
      <pp-account-user-management-header-custom-field [ppCustomField]="customField" />
    </div>
  }
</div>
